import React from "react";
import { Redirect as ReactRouterRedirect } from "react-router-dom";
import PropTypes from "prop-types";

export const Redirect = ({pathname, withSearch}) => {
  return (
    <ReactRouterRedirect to={{ pathname, search: withSearch ? globalThis.location.search : "" }} />
  );
};

Redirect.propTypes = {
  pathname: PropTypes.string,
  withSearch: PropTypes.bool,
};
